/**
 * 将文件大小转换为人类可读的格式
 * @param size - 文件大小（字节）
 * @returns 格式化后的文件大小字符串
 */
export function humanReadableSize(size: number) {
  const units = ["字节", "KB", "MB", "GB", "TB"];
  let i = 0;
  while (size >= 1024) {
    size /= 1024;
    i++;
  }
  return `${size.toFixed(1)} ${units[i]}`;
}
